import script from "./QueueReport.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueReport.vue?vue&type=script&setup=true&lang=js"

import "./QueueReport.vue?vue&type=style&index=0&id=d4603d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4603d5e"]])

export default __exports__